export enum IntervalEnum {
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year',
  WEEK = 'week',
}
